import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

const WelcomePageContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: auto;
    gap: 30px;
    box-shadow: none !important;
    padding: 0px;


    .welcomeText {
        font-weight: 600;
        font-size: 50px;
        width: 30%;
        justify-self: center;
        align-content: center;
        padding: 0px;
        position: absolute;
        bottom: 0;
        top: 0;
    }
`;

export default function WelcomePage() {
    //Rendering Functions
    return <WelcomePageContainer>
       <Typography className="welcomeText" color="primaryText">
           Welcome to {StaticDisplayText.APP_NAME}
       </Typography>
    </WelcomePageContainer>
}
